/**
 * 匿名ホットライン開示: 発注側（クライアント）
 */
export const HOTLINE_USER_TYPE_CLIENT = {
    value: 1,
};
/**
 * 匿名ホットライン開示: 提案側（コンサルタント）
 */
export const HOTLINE_USER_TYPE_PROFESSIONAL = {
    value: 2,
};
/**
 * 匿名ホットライン開示ステータス一覧
 */
export const HOTLINE_USER_TYPE = [
    HOTLINE_USER_TYPE_CLIENT,
    HOTLINE_USER_TYPE_PROFESSIONAL,
];
